import { Button, Typography } from '@/shared/ui';
import type { ErrorComponentProps } from '@tanstack/react-router';
import { useEffect, type FC } from 'react';

type GlobalErrorBoundaryProps = ErrorComponentProps;

export const GlobalErrorBoundary: FC<GlobalErrorBoundaryProps> = ({
  error,
}) => {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="bg-neutral-1 border-neutral-4 mx-auto mt-[144px] flex w-[600px] flex-col gap-6 border p-10">
      <div className="flex flex-col gap-2 text-center">
        <Typography variant="h1" weight="medium">
          Something Went Wrong
        </Typography>

        <Typography variant="body" weight="regular" className="opacity-85">
          We’re working to fix it. Please refresh the page or check back soon.
        </Typography>
      </div>

      <Button fullWidth size="large" onClick={() => location.reload()}>
        Refresh the page
      </Button>
    </div>
  );
};
